import { Outlet } from "react-router-dom";
import { TaskBar } from "./TaskBar";
import { SideBar } from "./SideBar";
import { Footer } from "./Footer";
import { useState } from "react";

export function Shell() {

  const [showSidebar, setShowSidebar] = useState(true);


  return (
    <div className="flex flex-col min-h-screen">
      <TaskBar showSidebar={showSidebar} setShowSidebar={setShowSidebar}/>
      <div className="flex flex-1 mt-14">
        <SideBar showSidebar={showSidebar}/>
        <main className={`flex-1 p-6 md:ml-48 overflow-y-auto bg-gray-100 text-gray-900`}>
          <Outlet />
        </main>
      </div>  
      <Footer/>
    </div>
  );
}
